/**
 * Prolean — responsive placement for the product-page benefits card.
 *
 * Desktop (≥ 750px): moves the benefits card beneath the product media column,
 * filling the space under the image and shortening the info column.
 * Mobile (< 750px): keeps it inline in the info column at its original position.
 *
 * Targets the enhanced card (.prolean-benefits-wrap, built asynchronously by
 * prolean-benefits-card.js). If the card enhancement is not active, falls back
 * to the plain .prolean-purchase-reassurance box.
 */
(() => {
  'use strict';

  if (window.__proleanBenefitsLayout) return;
  window.__proleanBenefitsLayout = true;

  const mq = window.matchMedia('(min-width: 750px)');

  function styleOnce() {
    if (document.getElementById('prolean-benefits-layout-style')) return;
    const s = document.createElement('style');
    s.id = 'prolean-benefits-layout-style';
    s.textContent =
      '.prolean-benefits-wrap.prolean-under-media,.prolean-purchase-reassurance.prolean-under-media{margin-top:1.5rem !important;}';
    document.head.appendChild(s);
  }

  function target() {
    const wrap = document.querySelector('.prolean-benefits-wrap');
    if (wrap) return wrap;
    // The benefits card is still being built from the reassurance box — wait for
    // the wrap rather than relocating the transient box (which gets replaced).
    if (window.__proleanBenefitsCard) return null;
    return document.querySelector('.prolean-purchase-reassurance');
  }

  function setup() {
    const el = target();
    const media =
      document.querySelector('.product__media-wrapper') ||
      document.querySelector('[class*="product__media-wrapper"]');
    if (!el || !media) return false;
    if (el.dataset.proleanPlaced) return true;

    const anchor = document.createComment('prolean-benefits-anchor');
    el.parentNode.insertBefore(anchor, el);
    el.dataset.proleanPlaced = 'true';

    const place = () => {
      if (mq.matches) {
        if (el.parentNode !== media) media.appendChild(el);
        el.classList.add('prolean-under-media');
      } else {
        if (el.previousSibling !== anchor) anchor.parentNode.insertBefore(el, anchor.nextSibling);
        el.classList.remove('prolean-under-media');
      }
    };
    place();
    mq.addEventListener ? mq.addEventListener('change', place) : mq.addListener(place);
    return true;
  }

  function start() {
    styleOnce();
    if (setup()) return;
    const mo = new MutationObserver(() => {
      if (setup()) mo.disconnect();
    });
    mo.observe(document.body, { childList: true, subtree: true });
    [150, 400, 900, 1800].forEach((ms) =>
      setTimeout(() => {
        if (setup()) mo.disconnect();
      }, ms),
    );
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();
